var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fillRule: "nonzero",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6515126,13.9022725 L22,19.2507601 L19.2507601,22 L13.9022725,16.6515126 C12.4976741,17.5508989 10.827813,18.07233 9.03616492,18.07233 C4.04562887,18.07233 0,14.0267011 0,9.03616492 C0,4.04562887 4.04562887,0 9.03616492,0 C14.0267011,0 18.07233,4.04562887 18.07233,9.03616492 C18.07233,10.827813 17.5508989,12.4976741 16.6515126,13.9022725 Z M9.03616492,14.1843175 C11.8794111,14.1843175 14.1843175,11.8794111 14.1843175,9.03616492 C14.1843175,6.19291889 11.8794111,3.8880125 9.03616492,3.8880125 C6.19291889,3.8880125 3.8880125,6.19291889 3.8880125,9.03616492 C3.8880125,11.8794111 6.19291889,14.1843175 9.03616492,14.1843175 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.637fd87abd9c4d99ccb497dd08a9cb91.svg";
export { ForwardRef as ReactComponent };